import { render, staticRenderFns } from "./add_commodity.vue?vue&type=template&id=784939ba&scoped=true"
import script from "./add_commodity.vue?vue&type=script&lang=js"
export * from "./add_commodity.vue?vue&type=script&lang=js"
import style0 from "./add_commodity.vue?vue&type=style&index=0&id=784939ba&prod&lang=scss"
import style1 from "./add_commodity.vue?vue&type=style&index=1&id=784939ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784939ba",
  null
  
)

export default component.exports